'use client';

import { AppProgressBar as ProgressBar } from 'next-nprogress-bar';

export function Progressbar(): JSX.Element {
  return (
    <ProgressBar
      color="rgb(var(--brand-500))"
      options={{ showSpinner: false }}
    />
  );
}
